var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('HintDesktop',{staticClass:"show-for-medium",attrs:{"message":_vm.message}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }